import React, { createContext, useState, useEffect, useContext } from 'react';

const ConfigContext = createContext(null);

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const backendUrl = (window.BACKEND_URL || process.env.REACT_APP_BACKEND_URL || "") || '';
        const response = await fetch(`${backendUrl}/api/public/config`);
        if (response.ok) {
          const data = await response.json();
          // Convert absolute URL if using relative path
          if (data.AGENCY_LOGO_DARK_URL?.startsWith('/')) {
            data.AGENCY_LOGO_DARK_URL = `${backendUrl}${data.AGENCY_LOGO_DARK_URL}`;
          }
          if (data.AGENCY_LOGO_LIGHT_URL?.startsWith('/')) {
            data.AGENCY_LOGO_LIGHT_URL = `${backendUrl}${data.AGENCY_LOGO_LIGHT_URL}`;
          }
          setConfig(data);
        } else {
          console.error("Failed to fetch branding config");
          setConfig({});
        }
      } catch (error) {
        console.error("Error fetching config:", error);
        setConfig({});
      } finally {
        setLoading(false);
      }
    };
    fetchConfig();
  }, []);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-gray-900 text-white">Loading...</div>;
  }

  return (
    <ConfigContext.Provider value={config || {}}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (context === null) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return context;
};
